<template>
  <v-container nowrap grid-list-md>
    <v-layout align-center justify-center>
      <v-flex xs6>
        <span class="font-weight-bold">Unidades Consumidoras</span>
      </v-flex>
      <v-flex xs6 class="endFlex">
        <v-btn
          color="#7d3dff"
          round
          fab
          small
          dark
          @click="openUcFormDialog = true"
          :disabled="isCorreios"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :headers="headers"
      :items="filteredQualifications"
      hide-actions
      no-data-text="Nenhuma Qualificação Encontrada"
    >
      <template v-slot:items="props">
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ props.item.consumer_unit }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ props.item.utility_company || "cemig" }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ address(props.item) }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          {{ props.item.status | formatUCStatus }}
        </td>
        <td :class="props.item.status | formatQualificationStatusColor">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
            v-if="canEdit(props.item.status)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
            v-if="canErase(props.item.status)"
          >
            delete
          </v-icon>
          <v-icon
            small
            @click="editItem(props.item)"
            v-if="!canEdit(props.item.status)"
          >
            visibility
          </v-icon>
        </td>
      </template>
    </v-data-table>

    <ConsumerUnitForm
      v-if="openUcFormDialog"
      :dialog="openUcFormDialog"
      :qualification="qualification"
      :qualification_ids="qualification_ids"
      :type="type"
      :isReSubscription="isReSubscription"
      :selected_plans="selected_plans"
      @closeDialog="closeDialog"
    />

    <v-dialog v-model="showCancellationDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="pa-0 pt-2">
          <span class="title font-weight-bold mx-auto"
            >Deseja remover essa qualificação?</span
          >
        </v-card-title>
        <v-card-text class="pt-2 pb-3">
          <div xs12 md12 class="dialog-container mx-4">
            <p class="">
              Essa qualificação não será considerada no momento da venda.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="closeCancellationDialog"
              >Fechar</v-btn
            >
            <v-btn color="pink darken-1" text @click="confirmCancellation"
              >Confirmar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import statesfile from "@/model/state";

export default {
  name: "ConsumerUnitList",

  props: {
    isReSubscription: {
      type: Boolean,
      default: false,
    },
    selected_plans: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    ConsumerUnitForm: () => import("./ConsumerUnitForm"),
  },

  data: () => ({
    headers: [
      {
        text: "Numero de Instalação",
        align: "left",
        value: "id",
      },
      { text: "Concessionária", value: "utility_company" },
      { text: "Endereço", value: "address" },
      { text: "Status", value: "status" },
      { text: "Ações", value: "", sortable: false },
    ],
    qualification: null,
    openUcFormDialog: false,
    type: "new",
    states: statesfile.estados,
    newQualifications: null,
    showCancellationDialog: false,
  }),

  computed: {
    ...mapState("qualification", ["qualifications"]),
    ...mapState("sales", ["isCorreios"]),

    qualification_ids() {
      return this.qualifications.map((qual) => qual.id) ?? [];
    },

    filteredQualifications() {
      return [...new Set(this.qualifications)];
    },
  },

  methods: {
    ...mapMutations("qualification", ["setQualifications"]),

    editItem(item) {
      this.openUcFormDialog = true;
      this.type = "edit";
      let uc = {};
      if (item.consumer_unit_detail?.address) {
        uc = item?.consumer_unit_detail;
      } else {
        const state_initials = item?.address?.slice(-2);
        const state = this?.states?.filter(
          (item) => item.initials === state_initials,
        )[0];
        const cep = item.address.match(/\b\d{5}-\d{3}\b/)[0];
        const allNumbers = item.address.match(/\d+/g);
        const secondNumber = allNumbers[allNumbers.length - 3];
        const district = item.address
          .match(new RegExp(secondNumber + "(.*?)" + cep, "i"))[1]
          .trim();
        const address_number = item.address.match(/\d+/)[0];
        const address_complement = item.address
          .match(new RegExp(address_number + "(.*?)" + district, "i"))[1]
          .trim();
        const _address = {
          address: item.address.match(/^([A-Z]+\s)+[A-Z]+/)[0],
          address_number: address_number,
          address_complement: address_complement || null,
          district: district || null,
          postal_code: cep,
          state: state || null,
          city: item.address.match(new RegExp(cep + "(.*?),"))[1].trim(),
          country: {
            name: "Brasil",
            initials: "BR",
          },
        };
        uc.address = _address;
        uc.customer_number = item.customer_number;
        uc.installation_number = item.consumer_unit;
        uc.rate_class = null;
        uc.sub_class = null;
      }
      this.qualification = {
        cpf: item.cpf,
        ...uc,
      };
    },

    deleteItem(item) {
      this.showCancellationDialog = true;
      const qualifications = this.qualifications.map((el) => el);
      this.newQualifications = qualifications.filter((i) => i.id !== item.id);
    },

    closeCancellationDialog() {
      this.showCancellationDialog = false;
      this.newQualifications;
    },

    confirmCancellation() {
      this.setQualifications(this.newQualifications);
      this.closeCancellationDialog();
    },

    address(qualification) {
      if (qualification?.consumer_unit_detail?.address) {
        const address = qualification?.consumer_unit_detail?.address;
        let _address = address.address;
        _address =
          _address +
          (address.address_number ? ", " + address?.address_number : "");
        _address =
          _address +
          (address.address_complement
            ? " - " + address?.address_complement
            : "");
        _address =
          _address + (address.district ? ", " + address?.district : "");
        _address = _address + (address.city ? ", " + address.city : "");
        _address =
          _address +
          (address.state?.initials ? " - " + address?.state?.initials : "");
        _address =
          _address +
          (address.postal_code ? " - CEP: " + address?.postal_code : "");
        return _address;
      } else return qualification.address;
    },

    canEdit(status) {
      const allowed_status = [
        "error",
        "bill_not_found",
        "pending",
        "canceled",
        "contract_not_signed",
      ];
      return allowed_status.includes(status);
    },
    canErase(status) {
      return (
        status === "error" ||
        status === "bill_not_found" ||
        status === "disqualified" ||
        status === "pending" ||
        status === "qualified"
      );
    },
    closeDialog() {
      this.qualification = null;
      this.openUcFormDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.endFlex {
  display: flex;
  justify-content: flex-end;
}
</style>
